'use client'

import { Languages } from 'lucide-react'
import { useLanguageToggle } from '@/hooks/use-language-toggle'
import { useTranslations } from 'next-intl'
import { GBFlag, DEFlag } from '@/components/ui/flags'
import { Button } from '@/components/ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'

export function LanguageToggle() {
	const { locale, changeLocale, mounted } = useLanguageToggle()
	const t = useTranslations('language')

	if (!mounted) {
		return <Button variant="ghost" size="icon" className="h-9 w-9"><Languages className="h-4 w-4" /></Button>
	}

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="ghost" size="icon" className="h-9 w-9">
					{locale === 'en' ? <GBFlag className="h-4 w-4" /> : <DEFlag className="h-4 w-4" />}
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end">
				<DropdownMenuItem onClick={() => changeLocale('en')} className={locale === 'en' ? 'bg-accent' : ''}>
					<GBFlag className="h-4 w-4 mr-2" />{t('en')}
				</DropdownMenuItem>
				<DropdownMenuItem onClick={() => changeLocale('de')} className={locale === 'de' ? 'bg-accent' : ''}>
					<DEFlag className="h-4 w-4 mr-2" />{t('de')}
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
